module.exports = __webpack_public_path__ + "static/media/Avatar7b.b376f448.png";